import { gql } from "@apollo/client";
import { CREDIT_FRAGMENT } from "./creditFragment";

export const GET_CREDIT_BY_REMITTANCE_ITEM_ID = gql`
${CREDIT_FRAGMENT}
query GetCreditByRemittanceItemId($params: CreditInput!) {
    credit(params: $params) {
        ...CreditFields
    }
}
`;